import React from 'react';
import Icon from '../../../components/AppIcon';

const ReportSelector = ({ selectedReport, onReportChange, reportTypes }) => {
  return (
    <div className="bg-card rounded-lg border border-border p-4 md:p-6">
      <h3 className="font-heading font-semibold text-lg md:text-xl mb-4 md:mb-6">
        Select Report Type
      </h3>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 md:gap-4">
        {reportTypes?.map((report) => (
          <button
            key={report?.id}
            onClick={() => onReportChange(report)}
            className={`
              p-4 md:p-5 rounded-lg border-2 transition-smooth hover-lift active-press text-left
              ${selectedReport?.id === report?.id
                ? 'border-primary bg-primary/5' :'border-border hover:border-primary/30 bg-card'
              }
            `}
          >
            <div className="flex items-start gap-3 md:gap-4">
              <div className={`
                w-10 h-10 md:w-12 md:h-12 rounded-md flex items-center justify-center flex-shrink-0
                ${selectedReport?.id === report?.id ? 'bg-primary/10' : 'bg-muted'}
              `}>
                <Icon
                  name={report?.icon}
                  size={20}
                  color={selectedReport?.id === report?.id ? 'var(--color-primary)' : 'var(--color-muted-foreground)'}
                />
              </div>
              <div className="flex-1 min-w-0">
                <h4 className="font-body font-semibold text-sm md:text-base text-foreground mb-1">
                  {report?.name}
                </h4>
                <p className="caption text-muted-foreground line-clamp-2">
                  {report?.description}
                </p>
              </div>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
};

export default ReportSelector;